export const arrayToQueryString = (array, key) => {
  return array.map(a => `${key}=${a}`).join("&");
};

export const toQueryString = paramsObject => {
  return Object.keys(paramsObject)
    .filter(key => paramsObject[key] != null)
    .map(
      key =>
        `${encodeURIComponent(key)}=${encodeURIComponent(paramsObject[key])}`
    )
    .join("&");
};

export const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " ").replace("/", ""));
};



// WEBPACK FOOTER //
// ./src/utils/queryHelpers.js